module.exports = __webpack_public_path__ + "img/duidaokuai.prt.79809765.jpg";